import React from "react";
import { Link } from "react-router-dom";
import { companyInfo } from "../mock";
import { LegalLayout, H2, P, InfoCard } from "./LegalLayout";

export default function Impressum() {
  return (
    <LegalLayout title="Impressum" subtitle="Angaben gemäß § 5 DDG" testId="impressum-page">
      <div className="grid md:grid-cols-2 gap-5">
        <InfoCard label="Diensteanbieter">
          <strong>Haustechnik Service Janzen</strong>
          <br />
          HTS Janzen Hausverwaltung
          <br />
          Inhaber: Simon Janzen
          <br />
          {companyInfo.address.street}
          <br />
          {companyInfo.address.zip} {companyInfo.address.city}
          <br />
          Deutschland
        </InfoCard>
        <InfoCard label="Kontakt">
          Telefon:{" "}
          <a href={`tel:${companyInfo.phone.replace(/\s/g, "")}`} className="underline">
            {companyInfo.phone}
          </a>
          <br />
          E-Mail:{" "}
          <a href={`mailto:${companyInfo.email}`} className="underline">
            {companyInfo.email}
          </a>
          <br />
          Web: www.hts-janzen.de
        </InfoCard>
        <InfoCard label="Berufsrechtliche Angaben">
          Gewerbliche Tätigkeit als Wohnimmobilienverwalter mit Erlaubnis nach § 34c Abs. 1 Satz 1
          Nr. 4 Gewerbeordnung (GewO).
          <br />
          Zuständige Erlaubnis- und Aufsichtsbehörde: Kreisverwaltung Kleve, Öffentliche Sicherheit
          &amp; Ordnung, Nassauerallee 12–16, 47533 Kleve.
          <br />
          Berufsrechtliche Regelungen: § 34c GewO, Makler- und Bauträgerverordnung (MaBV). Die
          Verwaltung erfolgt nach den Vorgaben des Wohnungseigentumsgesetzes (WEG), insbesondere
          §§ 19, 26 ff. WEG.
        </InfoCard>
        <InfoCard label="Vermögensschaden-Haftpflicht">
          Berufshaftpflichtversicherung für Vermögensschäden gemäß § 34c Abs. 2 Nr. 3 GewO i. V. m.
          §§ 15, 15a MaBV.
          <br />
          <strong>Debeka Allgemeine Versicherung AG</strong>
          <br />
          Debeka-Platz 1
          <br />
          56073 Koblenz
          <br />
          Räumlicher Geltungsbereich: Deutschland
        </InfoCard>
      </div>

      <H2>Verantwortlich für den Inhalt</H2>
      <P>
        Simon Janzen, {companyInfo.address.street}, {companyInfo.address.zip}{" "}
        {companyInfo.address.city}.
      </P>

      <H2>Streitschlichtung</H2>
      <P>
        Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
        <a
          href="https://ec.europa.eu/consumers/odr/"
          target="_blank"
          rel="noreferrer"
          className="underline text-brand-900"
        >
          https://ec.europa.eu/consumers/odr/
        </a>
        . Unsere E-Mail-Adresse finden Sie oben im Impressum.
      </P>
      <P>
        Wir sind nicht bereit und nicht verpflichtet, an Streitbeilegungsverfahren vor einer
        Verbraucherschlichtungsstelle teilzunehmen.
      </P>

      <H2>Haftung für Inhalte</H2>
      <P>
        Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene Inhalte auf diesen Seiten nach
        den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 DDG sind wir als Diensteanbieter
        jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen
        oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
      </P>
      <P>
        Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den
        allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst
        ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden
        von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
      </P>

      <H2>Haftung für Links</H2>
      <P>
        Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen
        Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.
        Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der
        Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf
        mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung
        nicht erkennbar.
      </P>

      <H2>Urheberrecht</H2>
      <P>
        Die durch den Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem
        deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
        Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des
        jeweiligen Autors bzw. Erstellers. Soweit die Inhalte auf dieser Seite nicht vom Betreiber
        erstellt wurden, werden die Urheberrechte Dritter beachtet.
      </P>

      <P>
        Hinweise zum Umgang mit Ihren Daten finden Sie in unserer{" "}
        <Link to="/datenschutz" className="underline text-brand-900" data-testid="impressum-privacy-link">
          Datenschutzerklärung
        </Link>
        .
      </P>
    </LegalLayout>
  );
}
